import React from "react";
import { Segment, Header, Grid, Card, Icon, Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const ReportesHome = () => {
  const navigate = useNavigate();

  const reportes = [
    {
      titulo: "Historial por Equipo",
      descripcion: "Consulta movimientos, mantenciones y estado histórico de un equipo.",
      icono: "heartbeat",
      ruta: "reporte1",
    },
    {
      titulo: "Historial por Paciente",
      descripcion: "Revisa equipos asociados y trazabilidad por paciente.",
      icono: "user",
      ruta: "reporte3",
    },
    {
      titulo: "Status de Equipos",
      descripcion: "Visualiza disponibilidad, ubicación y estado operacional.",
      icono: "stethoscope",
      ruta: "reporte2",
    },
    {
      titulo: "Movimientos",
      descripcion: "Consulta entradas, salidas, traslados y ajustes.",
      icono: "exchange",
      ruta: "reporte4",
    },
    {
      titulo: "Inventario Paciente",
      descripcion: "Listado de equipos asignados actualmente a pacientes.",
      icono: "clipboard list",
      ruta: "reporte5",
    },
  ];

  return (
    <div style={{ padding: "35px" }}>
      <Segment
        padded="very"
        style={{
          borderRadius: 18,
          border: "none",
          background: "linear-gradient(135deg, #e8f6fa, #ffffff)",
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <Header as="h2" style={{ color: "#168aad" }}>
          <Icon name="chart bar outline" />
          <Header.Content>
            Reportes
            <Header.Subheader>
              Selecciona el tipo de reporte que deseas consultar.
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Grid stackable columns={3} style={{ marginTop: 20 }}>
          {reportes.map((r) => (
            <Grid.Column key={r.titulo}>
              <Card fluid raised style={{ borderRadius: 14 }}>
                <Card.Content>
                  <Icon
                    name={r.icono}
                    size="big"
                    color="teal"
                    style={{ marginBottom: 12 }}
                  />
                  <Card.Header>{r.titulo}</Card.Header>
                  <Card.Description style={{ marginTop: 10 }}>
                    {r.descripcion}
                  </Card.Description>
                </Card.Content>
                <Card.Content extra>
                  <Button
                    fluid
                    color="teal"
                    onClick={() => navigate(r.ruta)}
                  >
                    Abrir reporte
                  </Button>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>
      </Segment>
    </div>
  );
};

export default ReportesHome;